import Crypto from 'crypto';

export var range = function range() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return Array.from(Array(Math.max(0, args[0] || 0)).keys());
  }
  // Assume second parameter is exclusive range to target
  return Array.from(Array(Math.max(0, (args[1] || 0) - (args[0] || 0))).keys()).map(function (n) {
    return n + args[0];
  });
};

export var parseSafeFloat = function parseSafeFloat(value) {
  if (value === '' || !value) {
    return 0;
  }

  var val = value.replace(',', '.');
  if (!val.match(/^(-?\d*|-?\d+(\.\d+)?)$/)) {
    return null;
  }

  var parsed = parseFloat(val, 10);
  if (Number.isNaN(parsed)) {
    return null;
  }

  return parsed;
};

export function diff(a, b) {
  var keys = Object.keys(a);
  var d = {};
  keys.forEach(function (key) {
    if (a[key] !== b[key]) {
      d[key] = b[key];
    }
  });
  return d;
}

export function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'); // eslint-disable-line
}

export function ExtendableBuiltin(cls) {
  function ExtendableBuiltinConstructor() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    cls.apply(this, args);
  }
  ExtendableBuiltinConstructor.prototype = Object.create(cls.prototype);
  Object.setPrototypeOf(ExtendableBuiltinConstructor, cls);

  return ExtendableBuiltinConstructor;
}

export var flatten = function flatten(list) {
  return list.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};

export function getScrollParent(node) {
  var isElement = node instanceof HTMLElement;
  var overflowY = isElement && window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

  if (!node) {
    return null;
  } else if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node;
  }

  return getScrollParent(node.parentNode) || document.body;
}

// Use this to prevent overscroll to trickle up to the document. In other words, prevent the page from scrolling when
// a div has reached end/start of scrollable content
// Code example
// <div onWheel={ scrollGuard } />
export function scrollGuard(e) {
  var node = e.currentTarget;
  if (node.clientHeight + node.scrollTop + e.deltaY >= node.scrollHeight) {
    e.preventDefault();
    node.scrollTop = node.scrollHeight; // eslint-disable-line no-param-reassign
  } else if (node.scrollTop + e.deltaY <= 0) {
    e.preventDefault();
    node.scrollTop = 0; // eslint-disable-line no-param-reassign
  }
}

export function truncateText(text, length) {
  var visualMax = length - 3;
  return text.length >= length ? text.substring(0, visualMax) + '...' : text;
}

export function hexgen(bytes) {
  var hexLength = Crypto.randomBytes(bytes || 6);
  return hexLength.toString('hex');
  // Bytes counts as 2, by default this function return a string with the leangth of 12;
}